import { render, staticRenderFns } from "./emptybactadi.vue?vue&type=template&id=41aea0d2&scoped=true"
import script from "./emptybactadi.vue?vue&type=script&lang=js"
export * from "./emptybactadi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aea0d2",
  null
  
)

export default component.exports